'use strict';


var ids = require('../identifiers'),
    frameRates = {
        Disabled: 0,
        '50_60': 6,
        '24_50_60': 7,
        '24_50': 3,
        '24_60': 5
    },
    gettext = require('mag-gettext').gettext;


module.exports = function ( config ) {
    var autoFrameRateVarName = 'auto_framerate',
        environment = {};

    environment[autoFrameRateVarName] = 'Disabled';

    return {
        id: 'autoFrameRate',
        advanced: true,
        name: gettext('Auto frame rate'),
        title: gettext('Auto frame rate'),
        description: [
            {
                label: gettext('Auto frame rate'),
                value: core.environment[autoFrameRateVarName]
            }
        ],
        icon: 'theme-icon-display',
        environment: environment,
        prepareForRender: function ( env, callback ) {
            var graphicResolutions = [
                {value: 'Disabled', name: gettext('Disabled'), selected: env[autoFrameRateVarName] === 'Disabled'},
                {value: '50_60', name: '50/60 Hz', selected: env[autoFrameRateVarName] === '50_60'},
                {value: '24_50_60', name: '24/50/60 Hz', selected: env[autoFrameRateVarName] === '24_50_60'},
                {value: '24_50', name: '24/50 Hz', selected: env[autoFrameRateVarName] === '24_50'},
                {value: '24_60', name: '24/60 Hz', selected: env[autoFrameRateVarName] === '24_60'}
            ];

            callback(graphicResolutions);
        },
        prepareForSave: function ( value, callback ) {
            this.environment[autoFrameRateVarName] = value;
            gSTB.SetAutoFrameRate(frameRates[value]);

            callback();
        },
        render: config.api.renders.popupSelect,
        getter: config.api.getters.environment,
        saver: config.api.savers.environment,
        parent: ids.video
    };
};
